import { createSlice } from "@reduxjs/toolkit";
import { businessSearchAction } from "../actions/GuestActions";

interface GuestState {
    user: {} | null
    loading: boolean;
    error: string | null;
    token: string
}

const initialState: GuestState = {
    user: null,
    token: "",
    loading: false,
    error: "",
};

const guestSlice = createSlice({
    name: "guest",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder

            .addCase(businessSearchAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(businessSearchAction.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(businessSearchAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message ?? "Something went wrong";
            })
    },
});

export default guestSlice.reducer;
